import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const aboveHeaderStyle = {
    background: 'whiteAlpha.800',
    'b, strong': {
        fontWeight: 'bold'
    },
    '.above-header-wrapper': {
        maxWidth: pxToRem(1346),
        margin: '0 auto',
        '#navigation': {
            '.top-header-bar': {
                position: 'relative',
                fontFamily: fonts.primary,
                ' z-index': '99',
                padding: `0 ${pxToRem(25)}`
            },
            '.top-header-bar.has-promo-banner .top-header-bar-inner': {
                display: 'flex',
                flexDirection: 'row-reverse',
                justifyContent: 'flex-end',
                alignItems: 'center',
                '.top-header-item': {
                    fontWeight: 700,
                    fontSize: pxToRem(11),
                    [`@media (min-width: ${size.md})`]: {
                        fontSize: pxToRem(14)
                    }
                }
            },
            '#header-promotion-banner': {
                [`@media (min-width: ${size.md}) and (max-width: ${size.lg})`]: {
                    width: pxToRem(215)
                },
                '.top-header-bar .header-promo-banner': {
                    background: 'whiteAlpha.800',
                    boxSizing: 'border-box',
                    float: 'right',
                    textAlign: 'right',
                    position: 'relative',
                    width: '42%'
                },
                '.top-header-bar .header-promo-banner .header-promotion': {
                    display: 'block'
                },
                '.header-promotion#insidePromo': {
                    height: pxToRem(32),
                    paddingLeft: pxToRem(0),
                    overflow: 'hidden'
                },
                '.header-promotion#insidePromo #nav': {
                    float: 'right',
                    margin: `${pxToRem(12)} ${pxToRem(0)}`,
                    position: 'relative',
                    'z-index': '999'
                },
                '.header-promotion#insidePromo #headPromoSlider': {
                    height: pxToRem(35),
                    overflow: 'hidden'
                },
                '#headPromoSlider p': {
                    margin: pxToRem(0),
                    padding: pxToRem(0),
                    whiteSpace: 'nowrap',
                    textAlign: 'left',
                    lineHeight: pxToRem(35),
                    height: pxToRem(35),
                    top: pxToRem(0),
                    background: 'transparent',
                    fontSize: pxToRem(12),
                    letterSpacing: pxToRem(2),
                    fontFamily: fonts.primary
                },
                '#headPromoSlider p a': {
                    color: 'blackAlpha.900',
                    display: 'inline-block',
                    marginTop: pxToRem(0),
                    marginRight: pxToRem(0),
                    padding: pxToRem(0),
                    fontWeight: 700,
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                    fontFamily: fonts.primary,
                    letterSpacing: pxToRem(4.16),
                    fontSize: [pxToRem(10), pxToRem(10), pxToRem(12), pxToRem(14)]
                },
                '#headPromoSlider p a:hover': {
                    color: 'cav_red'
                }
            },
            '.top-header-bar ul': {
                boxSizing: 'border-box',
                display: ['none', 'none', 'flex', 'flex'],
                alignItems: 'center',
                flexDirection: 'row',
                margin: pxToRem(-1),
                padding: pxToRem(0),
                'list-style-type': 'none',
                width: ['58%', '58%', '70%', '58%']
            },
            '.top-header-bar ul li': {
                display: 'inline-block'
            },
            '.top-header-bar ul li a': {
                fontSize: [pxToRem(11), pxToRem(11), pxToRem(11), pxToRem(14)],
                textDecoration: 'none',
                padding: pxToRem(0),
                margin: `${pxToRem(0)} ${pxToRem(20)} ${pxToRem(0)} ${pxToRem(0)}`,
                lineHeight: pxToRem(38),
                display: 'inline-block',
                fontFamily: fonts.primary,
                fontWeight: 700,
                letterSpacing: pxToRem(2),
                float: 'left',
                color: 'cav_red'
            },
            '.top-header-bar ul li a p': {
                display: 'flex',
                alignItems: 'center',
                marginBottom: pxToRem(2)
            },
            '.top-header-bar .user-links a': {
                fontSize: [pxToRem(11), pxToRem(11), pxToRem(11), pxToRem(14)],
                textDecoration: 'none',
                padding: pxToRem(0),
                margin: `${pxToRem(0)} ${pxToRem(20)} ${pxToRem(0)} ${pxToRem(0)}`,
                display: 'inline-block',
                lineHeight: pxToRem(18),
                letterSpacing: pxToRem(2)
            },
            '.top-header-bar .user-links a p': {
                marginLeft: pxToRem(0),
                marginBottom: pxToRem(8),
                whiteSpace: 'nowrap'
            },
            '.top-header-bar .logout-btn': {
                background: 'cav_dark_red',
                fontSize: pxToRem(14),
                color: 'white',
                width: '100%',
                fontWeight: 700,
                '&:hover': {
                    background: 'cav_red'
                }
            }
        },
        '.user-account': {
            position: 'relative',
            textTransform: 'uppercase'
        },
        '.user-panel': {
            boxSizing: 'content-box',
            textAlign: 'left',
            transition: 'all .3s ease',
            width: pxToRem(176),
            position: 'absolute',
            top: pxToRem(35),
            display: 'none',
            backgroundColor: 'white',
            color: 'black',
            border: `${pxToRem(1)} solid white`,
            padding: pxToRem(12),
            'z-index': '100'
        },
        '.user-panel.hide': {
            display: 'block'
        },
        [`@media (max-width: ${size.lg})`]: {
            '.user-panel': {
                width: pxToRem(144),
                padding: pxToRem(9)
            }
        },
        '.text': {
            color: 'black',
            fontFamily: fonts.primary,
            marginLeft: pxToRem(14),
            fontWeight: 400,
            letterSpacing: pxToRem(3.64)
        },
        '.text:hover': {
            color: 'cav_red'
        }
    }
}
